import script from "./employee-directory.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-directory.vue?vue&type=script&setup=true&lang=js"

import "./employee-directory.vue?vue&type=style&index=0&id=2aaf4a7f&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aaf4a7f"]])

export default __exports__